App.factory('ordersService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function OrdersService() {

        this.add = function(data) {
            return baseService.put(Config.API_URL + '/order/', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.addDoctor = function(data) {
            return baseService.put(Config.API_URL + '/order/visitRequest', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.addSurvey = function(data) {
            return baseService.put(Config.API_URL + '/order/laboratoryRequest', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new OrdersService();
}]);